import api from "../../utils/apiUserTienda";

export const getMetodosPago = async ({ page = 1, limit = 20 } = {}) => {
  const res = await api.get("/api/tienda/metodos_pago/obtener", {
    params: { page, limit },
  });
  return res.data;
};

export const getTiposPagoActivos = async () => {
  const res = await api.get("/api/tienda/metodos_pago/tipos/obtener/activos");
  return res.data; 
};

export const getPasarelasPagoActivas = async () => {
  const res = await api.get("/api/tienda/metodos_pago/pasarelas/activas");
  return res.data;
};

export const obtenerMetodosEnvioReglas = async () => {
  const res = await api.get("/api/tienda/metodos_pago/reglas/obtener");
  return res.data;
};

export const getMetodoPagoById = async (tiendaMetodoPagoId) => {
  const res = await api.get(
    `/api/tienda/metodos_pago/obtener/${tiendaMetodoPagoId}`
  );
  return res.data;
};


export const crearMetodoPago = async (payload) => {
    const res = await api.post("/api/tienda/metodos_pago/crear", payload);
    return res.data;
  };
  
  export const actualizarMetodoPago = async (tiendaMetodoPagoId, payload) => {
    const res = await api.put(
      `/api/tienda/metodos_pago/actualizar/${tiendaMetodoPagoId}`,
      payload
    );
    return res.data;
  };